const TabbedContent = (function ($) {
	return class {
		constructor($el) {
			this.$el = $el;
			this.$tabHeaders = $el.find('.ui__tab-header');
			this.$tabContent = $el.find('.ui__tab-content');
			this.$tabContentContainer = $el.find('.ui__tab-content-container');

			this.$tabHeaders.each(function (i) {
				$(this).attr('data-tab', i);
			});

			this.$tabContent.each(function (i) {
				$(this).attr('data-tab', i);
			});

			this.$tabHeaders.on('click tap', (e) => {
				const $curEl = $(e.currentTarget);

				e.preventDefault();

				this.$tabHeaders.removeClass('active');
				this.$tabContent.removeClass('active');

				$curEl.addClass('active');
				this.$tabContentContainer.find('[data-tab=' + $curEl.data('tab') + ']').addClass('active');
			});
		}
	};
})(jQuery);

export default TabbedContent;
